import { MapPin, Phone, Mail } from "lucide-react";
export default function OurNeighborhood() {
  return <section id="our-neighborhood" className="dark bg-background text-foreground relative w-full flex flex-col">
      {}
      <div className="w-full h-[50vh] min-h-[400px] relative bg-muted overflow-hidden">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3096.88414457993!2d-77.0543232234035!3d39.08643917168393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7cf66e5f8b9e1%3A0x296055c5678096e9!2s3914%20Ilford%20Rd%2C%20Silver%20Spring%2C%20MD%2020906!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full h-full grayscale opacity-60 contrast-125" title="Google Map of Family First Senior Care"></iframe>
        {}
        <div className="absolute inset-0 bg-primary/20 pointer-events-none mix-blend-overlay"></div>
        
        {}
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent pointer-events-none"></div>
      </div>

      {}
      <div className="w-full px-4 sm:px-6 lg:px-8 -mt-32 relative z-10 pb-24">
        <div className="max-w-4xl mx-auto bg-card text-card-foreground rounded-3xl shadow-2xl border border-border/50 p-8 md:p-12 lg:p-16 text-center backdrop-blur-sm">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary mb-8 ring-1 ring-primary/20">
            <MapPin className="w-8 h-8" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium mb-6 text-foreground tracking-tight">
            A Small Residential Home with Personalized Care for 5 Residents
          </h2>

          <div className="flex flex-col gap-4 mb-8 items-center text-muted-foreground">
            <p className="text-xl font-serif font-medium text-foreground">Family First Senior Care</p>
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm md:text-base">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-primary" />
                <span>3914 Ilford Rd, Silver Spring, MD 20906</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-primary" />
                <span>301-477-9779</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary" />
                <span>info@familyfirstassistedliving.org</span>
              </div>
            </div>
          </div>
          
          <div className="w-12 h-1 bg-primary mx-auto mb-8 rounded-full opacity-50"></div>
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto font-sans">
            Family First Senior Care is a small residential assisted-living home in Silver Spring, Maryland, offering personalized care for up to 5 residents in a warm, family-like atmosphere. Our home provides a safe, peaceful environment with 24/7 support, ensuring every senior receives the dedicated attention they deserve.
          </p>

          <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto font-sans">
            We invite you to experience the warmth of our home firsthand. Please call us at <span className="text-foreground font-medium">301-477-9779</span> or schedule a tour to see how we provide the personalized care your loved one deserves.
          </p>
        </div>
      </div>
    </section>;
}